module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[65]430.98709b9.woff2";